import { render, staticRenderFns } from "./DetalhesDadosGeraisContrato.vue?vue&type=template&id=6fa0fa28"
import script from "./DetalhesDadosGeraisContrato.vue?vue&type=script&lang=ts"
export * from "./DetalhesDadosGeraisContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports